module.exports = __webpack_public_path__ + "img/logorobotlampara.c707ffb5.png";